import { BlockProps } from '@features/main-page-builder/model/blockRegistry'
import styles from '@features/main-page-builder/ui/styles.module.scss'

import { LoyaltyProgress } from '@widgets/loyalty/LoyaltyProgress'

export default function CustomBlock ({
  block
}: BlockProps) {
  // Render custom content based on subtype
  switch (block.subtype) {
  case 'loyaltyProgress':
    return (
      <div className={styles.root__custom}>
        <LoyaltyProgress />
      </div>
    )
    
  default:
    return (
      <div>
      </div>
    )
  }
}